export default function CategoryCard({ number, title, options }) {
  return (
    <div className="space-y-4 mb-4">
      <div className="bg-white rounded-2xl p-6 text-black">
        <div className="flex items-start gap-4">
          <span className="text-2xl font-bold text-black">{number}</span>
          <div>
            <h3 className="text-xl font-bold mb-3">{title}</h3>
            <ul className="space-y-1 text-gray-700">
              {options && options.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
